import { Link, useLocation } from 'react-router-dom';
import { useWishlist } from '../../context/WishlistContext';
import { useAuth } from '../../context/AuthContext';

const HomeIcon = ({ active }) => (
  <svg className="w-5 h-5" fill={active ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={active ? 0 : 2}
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
  </svg>
);

const ShopIcon = ({ active }) => (
  <svg className="w-5 h-5" fill={active ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={active ? 0 : 2}
      d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
  </svg>
);

const OffersIcon = ({ active }) => (
  <svg className="w-5 h-5" fill={active ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={active ? 0 : 2}
      d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z"/>
  </svg>
);

const HeartIcon = ({ active }) => (
  <svg className="w-5 h-5" fill={active ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={active ? 0 : 2}
      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
  </svg>
);

const AccountIcon = ({ active }) => (
  <svg className="w-5 h-5" fill={active ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={active ? 0 : 2}
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
  </svg>
);

const MobileBottomNav = () => {
  const location = useLocation();
  const { itemCount: wishlistCount } = useWishlist();
  const { user } = useAuth();

  if (location.pathname.startsWith('/checkout')) return null;

  const isActive = (to) => {
    if (to === '/') return location.pathname === '/';
    const [path, queryStr] = to.split('?');
    if (!location.pathname.startsWith(path)) return false;
    if (queryStr) {
      const p = new URLSearchParams(queryStr);
      const c = new URLSearchParams(location.search);
      return [...p].every(([k, v]) => c.get(k) === v);
    }
    // For /shop without query: not active when ?sale=1 is present
    if (path === '/shop') {
      return new URLSearchParams(location.search).get('sale') !== '1';
    }
    return true;
  };

  const items = [
    { label: 'Home',     to: '/',           icon: HomeIcon    },
    { label: 'Shop All', to: '/shop',        icon: ShopIcon    },
    { label: 'Offers',   to: '/shop?sale=1', icon: OffersIcon  },
    { label: 'Wishlist', to: '/wishlist',    icon: HeartIcon, badge: wishlistCount },
    { label: 'Account',  to: user ? '/account' : '/login', icon: AccountIcon },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-border
                    shadow-[0_-2px_12px_rgba(0,0,0,0.08)]">
      <div className="flex items-stretch h-14">
        {items.map(({ label, to, icon: Icon, badge }) => {
          const active = isActive(to);
          return (
            <Link
              key={label}
              to={to}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 relative transition-colors
                ${active ? 'text-primary' : 'text-ink-muted'}`}
            >
              <div className="relative">
                <Icon active={active} />
                {badge > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 w-4 h-4 text-[9px] font-bold bg-accent text-white rounded-full flex items-center justify-center">
                    {badge > 9 ? '9+' : badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] font-medium ${active ? 'text-primary' : 'text-ink-muted'}`}>
                {label}
              </span>
              {active && <div className="absolute top-0 inset-x-0 h-0.5 bg-primary rounded-b-full" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
